import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";

export default function FaqAccordion({ items, testPrefix = "faq" }) {
  const [open, setOpen] = useState(0);
  if (!items?.length) return null;

  return (
    <div className="space-y-3">
      {items.map((item, i) => {
        const isOpen = open === i;
        return (
          <div key={i} className={`overflow-hidden rounded-2xl border transition-colors duration-300 ${isOpen ? "border-gold/40 bg-navy-850" : "border-gold/12 bg-navy-900/60"}`} data-testid={`${testPrefix}-item-${i + 1}`}>
            <button onClick={() => setOpen(isOpen ? -1 : i)} className="flex w-full items-center justify-between gap-4 p-5 text-right" data-testid={`${testPrefix}-toggle-${i + 1}`}>
              <span className={`font-display text-sm font-bold leading-7 sm:text-base ${isOpen ? "text-gold" : "text-slate-100"}`}>{item.q}</span>
              <motion.span animate={{ rotate: isOpen ? 45 : 0 }} transition={{ duration: 0.3 }} className={`shrink-0 ${isOpen ? "text-gold" : "text-slate-500"}`}>
                <Plus size={18} />
              </motion.span>
            </button>
            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }} className="overflow-hidden">
                  <p className="border-t border-gold/10 p-5 pt-4 text-sm leading-8 text-slate-400" data-testid={`${testPrefix}-answer-${i + 1}`}>{item.a}</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
}
